import type { Resource } from "./resources_config";

// Backend-only resource for Stripe webhook events - no UI components
const stripeEvents: Resource = {
	name: "stripe_events",
	apiPath: "/stripe_events",
	path: "/stripe_events",
};

export default stripeEvents;
